import {
  PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_BEGIN,
  PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_SUCCESS,
  PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_FAILURE,
  PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_DISMISS_ERROR,
} from './constants';
import { getEndpoint } from '../../common/backend/endpoints'
import axios from 'axios'

export function listaDePresupuestos(queryString, setCancelToken) {
  return (dispatch) => {
    dispatch({
      type: PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_BEGIN,
    });

    const endpoint = getEndpoint('PRESUPUESTADOR')

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios(endpoint + queryString, {
        cancelToken: new axios.CancelToken(setCancelToken),
      })
      doRequest.then(
        (res) => {
          dispatch({
            type: PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_SUCCESS,
            data: {
              data: res.data.data,
              pagination: res.data.pagination
            }
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissListaDePresupuestosError() {
  return {
    type: PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        listaDePresupuestosPending: true,
        listaDePresupuestosError: null,
      };

    case PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_SUCCESS:
      // The request is success
      return {
        ...state,
        listaDePresupuestosPending: false,
        listaDePresupuestosError: null,
        listaDePresupuestos: action.data.data,
        listaDePresupuestosPagination: action.data.pagination
      };

    case PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_FAILURE:
      // The request is failed
      return {
        ...state,
        listaDePresupuestosPending: false,
        listaDePresupuestosError: action.data.error.message,
      };

    case PRESUPUESTADOR_LISTA_DE_PRESUPUESTOS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        listaDePresupuestosError: null,
      };

    default:
      return state;
  }
}
